
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { httpAuthService } from '@commons';
import { path } from '@commons/path';
import { trackEvent } from 'mixpanel';

import blankProfile from '../../assets/images/users/blank-profile-picture.png';
import TrialLicenseTime from '@components/common/TrialLicenseTime';
import { CREATE_TRACK_MOD_LOG } from '@handler';
import { MODULES_ENUM } from '@handler/tracking/moduleLog/modulesEnum';
import { MODULE_FUNCTIONALITY_ENUM } from '@handler/tracking/moduleLog/moduleFunctionalityEnum';
import { handleSSORedirect } from 'services/zendesk/handleSSORedirect';
import { ZendeskAPI } from 'ZendeskConfig';

class ProfileMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }


    render() {
        const { loginReducer, startSessionReducer } = this.props;

        return (
            <React.Fragment>
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block" >
                    <DropdownToggle className="btn header-item waves-effect" id="page-header-user-dropdown" tag="button">
                        {/* <i className="mdi mdi-cowboy font-size-17 primary-color" style={{ marginRight: '5px' }} />
                        <span className="primary-color">
                            {loginReducer.user.name.split(' ').shift() + "  "}
                        </span>
                        <i className="fa fa-angle-down primary-color" /> */}
                        <img className="rounded-circle header-profile-user" src={blankProfile} alt="Header Avatar" />
                    </DropdownToggle>
                    <DropdownMenu right>
                        <div className="trial-license-mobile-wrapper">
                            <div className="mr-2 ml-2">
                                <TrialLicenseTime />
                            </div>
                            <div className="dropdown-divider"></div>
                        </div>

                        <React.Fragment>
                            {loginReducer.user.perfil === 'SUPORTE_AGRARE' ? (
                                <DropdownItem tag="a" href="/corporate/contaProdutor" onClick={() => {}}>
                                    <i className="fa fa-home font-size-17 align-middle mr-1" />Página Inicial
                                </DropdownItem>
                            ) : (
                                <DropdownItem tag="a" href="/home" onClick={() => trackEvent('Clicou no Profile Menu > Página Inicial On Farm')}>
                                    <i className="fa fa-home font-size-17 align-middle mr-1" />Página Inicial On Farm
                                </DropdownItem>
                            )}
                            <div className="dropdown-divider"></div>
                        </React.Fragment>

                        <DropdownItem
                            tag="a"
                            href="/minhasFazendas"
                            onClick={() => {
                                trackEvent('Clicou no Profile Menu > Fazendas');
                                this.props.trackingEvent(MODULES_ENUM.GERAL, MODULE_FUNCTIONALITY_ENUM.PROPRIEDADE);
                            }}
                        >
                            <i className="mdi mdi-wallet font-size-17 align-middle mr-1" />Fazendas
                        </DropdownItem>
                        <DropdownItem
                            tag="a"
                            href="/seguranca/usuario"
                            onClick={() => {
                                trackEvent('Clicou no Profile Menu > Usuários');
                                this.props.trackingEvent(MODULES_ENUM.GERAL, MODULE_FUNCTIONALITY_ENUM.USUARIO);
                            }}
                        >
                            <i className="mdi mdi-account-multiple font-size-17 align-middle mr-1" />Usuários
                        </DropdownItem>
                        <hr />
                        <DropdownItem
                            tag="a"
                            href="/config"
                            onClick={() => {
                                trackEvent('Clicou no Profile Menu > Configurações');
                                this.props.trackingEvent(MODULES_ENUM.GERAL, MODULE_FUNCTIONALITY_ENUM.CONFIG);
                            }}
                        >
                            <i className="mdi mdi-settings font-size-17 align-middle mr-1" />Configurações
                        </DropdownItem>
                        <hr />
                        <DropdownItem
                            tag="a"
                            style={{cursor: 'pointer'}}
                            onClick={() => {
                                trackEvent('Clicou no Profile Menu > Central de Ajuda');
                                this.props.trackingEvent(MODULES_ENUM.GERAL, MODULE_FUNCTIONALITY_ENUM.HELP_CENTER);
                                handleSSORedirect();
                            }}
                        >
                            <i className="fa fa-headset font-size-17 align-middle mr-1" />Central de Ajuda
                        </DropdownItem>
                        <DropdownItem tag="a" href="https://forms.gle/pmP8qsG1MDYyLaCk8" target='_blank' onClick={() => trackEvent('Clicou no Profile Menu > Deixe seu Feedback')}>
                            <i className="mdi mdi-comment-question-outline font-size-17 align-middle mr-1" />Deixe seu Feedback
                        </DropdownItem>
                        <DropdownItem tag="a" href="https://forms.gle/zJtvoW8VJi89Vetp9" target='_blank' onClick={() => trackEvent('Clicou no Profile Menu > Sugira uma Funcionalidade')}>
                            <i className="mdi mdi-lightbulb font-size-17 align-middle mr-1" />Sugira uma Funcionalidade
                        </DropdownItem>
                        <DropdownItem tag="a" href="https://agrare.com.br/termos-de-uso" target='_blank' onClick={() => trackEvent('Clicou no Profile Menu > Termos de Uso')}>
                            <i className="mdi mdi-alert font-size-17 align-middle mr-1" />Termos de Uso
                        </DropdownItem>
                        <div className="dropdown-divider"></div>
                        <Link
                            to="/login"
                            onClick={() => {
                                trackEvent('Clicou no Profile Menu > Sair do Sistema')
                                httpAuthService.logout({ path });
                                document.body.classList.add('zendesk-hide');
                                ZendeskAPI('messenger', 'hide');
                            }}
                            className="dropdown-item">
                            <i className="mdi mdi-logout font-size-17 align-middle mr-1"></i>
                            <span>Sair do Sistema</span>
                        </Link>
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}

export function mapStateToProps(state) {
    const { loginReducer, startSessionReducer } = state.entities;
    return { loginReducer, startSessionReducer };
};

function mapDispatchToProps(dispatch) {
    return {
        trackingEvent: (module, functionality) => dispatch({ type: CREATE_TRACK_MOD_LOG, module, functionality }),
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ProfileMenu));
